const getEmergencyContactByPassenger = (passenger, passengers) => {
  const { emergencyContact } = passenger.travelerPreferences;
  if (passenger.doUsePrimaryTravelerAsEmergencyContact) {
    if (passengers[0].doUseTravelerInfoAsEmergencyContact) {
      return {
        phoneNumber: passengers[0].phone,
        contactEmail: passengers[0].contactEmail,
      };
    } return !passengers[0].travelerPreferences.emergencyContact
      ? passengers[0].travelerPreferences.emergencyContact : {
        ...passengers[0].travelerPreferences.emergencyContact,
        phoneNumber: passengers[0].travelerPreferences.emergencyContact.phoneNumber,
      };
  }
  if (passenger.doUseTravelerInfoAsEmergencyContact) {
    return {
      phoneNumber: passenger.phone,
      contactEmail: passenger.contactEmail,
    };
  }
  return emergencyContact ? {
    ...emergencyContact,
    phoneNumber: emergencyContact.phoneNumber,
  } : emergencyContact;
};

export default getEmergencyContactByPassenger;
